(function () {
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const ENABLED_KEY = 'vetway_snow_enabled';
  const month = new Date().getMonth(); // 0=Jan … 11=Dec
  // Auto-on in December by default; user toggle overrides
  const defaultEnabled = (month === 11);
  const stored = localStorage.getItem(ENABLED_KEY);
  let enabled = stored === null ? defaultEnabled : stored === 'true';
  if (!enabled || prefersReduced) return;

  const canvas = document.createElement('canvas');
  canvas.id = 'vetway-snow';
  canvas.style.cssText = 'position:fixed;inset:0;pointer-events:none;z-index:9999;block-size:100vh;inline-size:100vw;';
  document.documentElement.appendChild(canvas);

  const ctx = canvas.getContext('2d');
  let w, h, dpr, flakes = [], running = true;
  const MAX_FLAKES_BASE = 110; // Adjust density here

  function resize() {
    dpr = Math.max(1, Math.min(window.devicePixelRatio || 1, 2));
    w = canvas.clientWidth = window.innerWidth;
    h = canvas.clientHeight = window.innerHeight;
    canvas.width = Math.floor(w * dpr);
    canvas.height = Math.floor(h * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  function makeFlake() {
    const size = Math.random() * 2.2 + 0.8;       // px
    const speed = Math.random() * 0.6 + 0.35;     // px/frame
    const sway = Math.random() * 0.8 + 0.2;       // horizontal drift
    return {
      x: Math.random() * w,
      y: -10 - Math.random() * h,
      r: size,
      v: speed,
      a: Math.random() * Math.PI * 2,
      s: sway
    };
  }

  function populate() {
    const target = Math.floor(MAX_FLAKES_BASE * (w * h) / (1440 * 900)); // scale with viewport
    flakes = [];
    for (let i = 0; i < target; i++) flakes.push(makeFlake());
  }

  function draw() {
    if (!running) return;
    ctx.clearRect(0, 0, w, h);
    ctx.globalAlpha = 0.9;
    ctx.fillStyle = 'rgba(255,255,255,0.9)';
    for (let f of flakes) {
      f.a += 0.01;
      f.y += f.v;
      f.x += Math.cos(f.a) * f.s * 0.6;

      // wrap
      if (f.y > h + 6) { f.y = -8; f.x = Math.random() * w; }
      if (f.x > w + 6) f.x = -6;
      if (f.x < -6) f.x = w + 6;

      ctx.beginPath();
      ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2);
      ctx.fill();
    }
    requestAnimationFrame(draw);
  }

  // Pause when tab hidden
  document.addEventListener('visibilitychange', () => {
    running = !document.hidden;
    if (running) requestAnimationFrame(draw);
  });

  window.addEventListener('resize', () => { resize(); populate(); });
  resize(); populate(); requestAnimationFrame(draw);

  // Expose a tiny toggle API (for the button below)
  window.VetwaySnow = {
    disable() { localStorage.setItem(ENABLED_KEY, 'false'); location.reload(); },
    enable() { localStorage.setItem(ENABLED_KEY, 'true'); location.reload(); },
    isEnabled() { return enabled; }
  };
})();
